import React, { useState } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import Dotdotdot from 'react-dotdotdot'

const ToggleIcon = styled.i`
  font-size: 20px;
  position: absolute;
  right: 11px;
  cursor: pointer;
  color: ${props => (props.isOpen ? '#003399' : '#7c7c7c')};
  top: ${props => (props.customTop ? props.customTop : '5px')};
`
const ContentToggle = styled.div`
  color: #4a4a4a;
  font-size: 14px;
  line-height: 16px;
  padding-top: 10px;
  display: ${props => (props.isOpen ? 'block' : 'none')};
`

function SearchResult({ toggleContent, customTop, truncateContent, children }) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  return (
    <>
      <ToggleIcon
        className={`far ${isDetailsOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
        isOpen={isDetailsOpen}
        onClick={() => {
          setIsDetailsOpen(prevIsDetailsOpen => !prevIsDetailsOpen)
        }}
        customTop={customTop}
      />
      {children}
      <ContentToggle isOpen={isDetailsOpen}>
        {truncateContent ? (
          <Dotdotdot clamp={4}>{toggleContent}</Dotdotdot>
        ) : (
          <div>{toggleContent}</div>
        )}
      </ContentToggle>
    </>
  )
}

SearchResult.propTypes = {
  toggleContent: PropTypes.node,
  customTop: PropTypes.string,
  truncateContent: PropTypes.bool,
  children: PropTypes.node
}

SearchResult.defaultProps = {
  truncateContent: true
}

export default SearchResult
